/// <amd-module name="@vergleichde/locale-formatter"/>
define("@vergleichde/locale-formatter", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var nonBreakableSpace = String.fromCharCode(160);
    function numberWithoutThousandsSeparator(value, decimalsParameter) {
        if (value === null || isNaN(value)) {
            return NaN;
        }
        var decimals = decimalsParameter || 0;
        return parseFloat(value).toFixed(decimals).toString().replace(".", ",");
    }
    exports.numberWithoutThousandsSeparator = numberWithoutThousandsSeparator;
    function numberWithThousandsSeparator(value, decimalsParameter) {
        if (value === null || isNaN(value)) {
            return NaN;
        }
        var thousandsSeparatorRegex = /\B(?=(\d{3})+(?!\d))/g;
        var valueAsString = numberWithoutThousandsSeparator(value, decimalsParameter);
        var valueParts = valueAsString.split(",");
        valueAsString = valueParts[0].replace(thousandsSeparatorRegex, ".");
        if (decimalsParameter > 0) {
            valueAsString += "," + valueParts[1];
        }
        return valueAsString;
    }
    exports.numberWithThousandsSeparator = numberWithThousandsSeparator;
    function percentage(value) {
        if (value === null || isNaN(value)) {
            return NaN;
        }
        return value.toFixed(2).toString().replace(".", ",") + nonBreakableSpace + "%";
    }
    exports.percentage = percentage;
    function currency(value) {
        return unit(value, "€");
    }
    exports.currency = currency;
    function currencyWithFraction(value) {
        if (value === null || isNaN(value)) {
            return NaN;
        }
        var amountAsString = numberWithThousandsSeparator(value, 2);
        return amountAsString + nonBreakableSpace + "€";
    }
    exports.currencyWithFraction = currencyWithFraction;
    function appendMonate(monate, useDative) {
        if (monate === 0) {
            return "";
        }
        var jahrMonateText = " und ";
        if (monate === 1) {
            if (useDative) {
                jahrMonateText += "einem Monat";
            }
            else {
                jahrMonateText += "ein Monat";
            }
        }
        else if (monate > 1) {
            if (useDative) {
                jahrMonateText += monate + " Monaten";
            }
            else {
                jahrMonateText += monate + " Monate";
            }
        }
        return jahrMonateText;
    }
    function monthsToYears(numberOfMonths, useDative) {
        var years = Math.floor(numberOfMonths / 12);
        var months = numberOfMonths % 12;
        var yearsAsText = useDative
            ? "n"
            : "";
        return years + " Jahre" + yearsAsText + appendMonate(months, useDative);
    }
    exports.monthsToYears = monthsToYears;
    function dateAsGermanLocaleDateString(date) {
        function pad(n) {
            return n < 10
                ? "0" + n
                : n;
        }
        return [
            pad(date.getDate()),
            pad(date.getMonth() + 1),
            date.getFullYear(),
        ].join(".");
    }
    exports.dateAsGermanLocaleDateString = dateAsGermanLocaleDateString;
    function unit(value, unitSymbol) {
        if (value === null || isNaN(value)) {
            return NaN;
        }
        var amountAsString = numberWithThousandsSeparator(value, 0);
        if (unitSymbol === "") {
            return amountAsString;
        }
        return amountAsString + nonBreakableSpace + unitSymbol;
    }
    exports.unit = unit;
});
